import {isCustomerNotification} from "../customer-notifications";

export default class Notifications {
    constructor(Notification, $cookies, $location, $rootScope, $filter, $timeout, NotificationMessageBuilder, Fanout) {

        this._cookies = $cookies;
        this._location = $location;
        this._rootScope = $rootScope;
        this._filter = $filter;
        this._timeout = $timeout;

        this.notificationRepo = Notification;
        this.notificationMessageBuilder = NotificationMessageBuilder;
        this.fanout = Fanout;

        this.shouldWatch = false;
        this.isRunning = false;
        this.myNotifications = [];
        this.notificationToken = '';
        this.pollingTimeout = null;
        this.stopped = false;
        this.that = this;
    }

    notifications() {
        return this.myNotifications;
    };

    handleResponse(response) {
        _.each(response.data, (notification) => {
            this.decorateNotification(notification);

            if (this.that.isProgress(notification)) {
                this.shouldWatch = true;
            }

            this.myNotifications.push(notification);
        })
    };

    initialize() {
        this.that = this;
        this.notificationRepo.all().then((results) => {
            this.handleResponse(results);
        });
    };

    clear() {
        this.myNotifications = [];
    };

    getPage(page) {
        this.notificationRepo.all(page).then((results) => {
            this.handleResponse(results);
        });
    };

    handleIncomingNotification(data) {
        let notification = data.data;
        let isNewNotification = true;

        for (let i = 0; i < this.myNotifications.length; i++) {
            if (this.myNotifications[i].id === notification.id) {
                if (this.isProgress(notification)) {
                    this.myNotifications[i].progress = notification.progress;
                }
                isNewNotification = false;
            }
        }

        if (isNewNotification) {

            this.decorateNotification(notification);
            this.myNotifications.unshift(notification);
        }

        return isNewNotification;
    };

    decorateNotification(notification) {
        notification.date = this._filter('toDate')(notification.created_at, 'yyyy-MM-dd');
        let customerNotification = isCustomerNotification(notification);

        notification.title = this.notificationMessageBuilder.getMessageFor(notification, 'title');
        notification.description = this.notificationMessageBuilder.getMessageFor(notification, 'description');

        if (customerNotification) {
            notification.custom_data = JSON.parse(notification.custom_data);
            notification.isCustomerNotification = true;
            notification.title = notification.title || notification.custom_data.title;
            notification.description = notification.description || notification.custom_data.body;
        } else {
            notification.link = this.notificationMessageBuilder.getLink(notification);
        }

        if (notification.custom_data && notification.notification_type_id !== 6 && !customerNotification) {
            notification.description += ' ' + notification.custom_data;
        }
    }

    removeTrashed() {
        for (let i = 0; i < this.myNotifications.length; i++) {
            if (this.myNotifications[i].trashed === true) {
                this.myNotifications.splice(i, 1);
            }
        }
    };

    remove(notification) {
        // can't use $index here because it does not represent the original array
        _.each(this.myNotifications, (item, index) => {
            if (item && item.id === notification.id) {
                this.myNotifications.splice(index, 1);
            }
        })
    };

    isProgress(notification) {
        return notification && notification.method && notification.method.id === 2;
    };

    listenToFanout(scope) {
        if (this.notificationToken !== this._cookies.get('notification_token')) {
            this.notificationToken = this._cookies.get('notification_token');
            this.fanout.client.subscribe('/' + this.notificationToken, (data) => {

                data = JSON.parse(data);
                let isNewNotification = this.that.handleIncomingNotification(data);
                if (isNewNotification) {
                    scope.notificationsCount++;
                    this._cookies.put('notificationsCount', scope.notificationsCount);
                    scope.notificationsVisible = true;
                }
                this.that._rootScope.$broadcast('notifications:changed');
            });

            var environment = '';

            switch(this._location.host()) {
                case 'rule-dev':
                    environment = 'local';
                    break;
                case 'staging.rule.io':
                    environment = 'staging';
                    break;
                case 'staging2.rule.io':
                    environment = 'staging';
                    break;
                case 'app.rule.io':
                    environment = 'production';
                    break;
            }
            if (environment !== '') {
                this.fanout.client.subscribe('/global/' + environment, (data) => {
                    if (data === 'newUpdateAvailable' && ! scope.updateNotificationVisible) {
                        notify({
                            message: this._filter('translate')('GLOBAL:UPDATE_AVAILABLE_DESCRIPTION'),
                            duration: '0',
                            classes: ['issue-update-notification'],
                            position: 'right',
                            template: require('../../../../views/directives/angular-notify/available-update.html')
                        });
                        scope.updateNotificationVisible = true;
                    }
                })
            }
        }
    };
}
